import { NavLink } from 'react-router-dom'
import { Home, TrendingUp, BookOpen } from 'lucide-react'
import { SystemIcon, AccountIcon } from '@/lib/entity-icons'
import { cn } from '@/lib/utils'
import { useAuthStore } from '@/stores/authStore'
import { useUIConfig } from '@/hooks/use-ui-config'
import gridxLogo from '@assets/logos/gridx.png'

export const navigation = [
  { name: 'Dashboard', href: '/', icon: Home },
  { name: 'Accounts', href: '/accounts', icon: AccountIcon },
  { name: 'Systems', href: '/systems', icon: SystemIcon },
  { name: 'Savings Simulator', href: '/simulator', icon: TrendingUp },
  { name: 'Documentation', href: '/docs', icon: BookOpen },
]

export default function Sidebar() {
  const environment = useAuthStore((state) => state.environment)
  const { hiddenNavItems } = useUIConfig()
  const visibleNavigation = navigation.filter((item) => !hiddenNavItems.includes(item.href))

  return (
    <div className="flex h-full w-64 flex-col bg-muted/40 border-r relative z-10">
      {/* Logo */}
      <div className="flex h-16 items-center gap-2.5 px-6 border-b">
        <img src={gridxLogo} alt="gridX" className="h-7 w-auto" />
        <span className="text-sm font-bold tracking-tight">XENON Flex Demo</span>
      </div>

      {/* Environment Badge */}
      <div className="px-6 py-4 border-b">
        <div
          className={cn(
            'inline-flex items-center rounded-full px-3 py-1 text-xs font-medium',
            environment === 'production'
              ? 'bg-green-100 text-green-800'
              : 'bg-yellow-100 text-yellow-800'
          )}
        >
          {environment === 'production' ? 'Production' : 'Staging'}
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-1 px-3 py-4">
        {visibleNavigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            end={item.href === '/'}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'
              )
            }
          >
            <item.icon className="h-5 w-5" />
            {item.name}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="border-t px-6 py-4">
        <p className="text-xs text-muted-foreground">© 2026 gridX GmbH</p>
      </div>
    </div>
  )
}
